import React from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "../../pages/landing/ln.scss";
import "./styles.scss";

// Ro'yxatdan o'tish sahifalari uchun umumiy ramka: sarlavha, qadamlar va forma kartasi
function RegShell({ t, step, children }) {
  const steps = [t("First step"), t("Last step")];
  return (
    <div className="ln-reg ln">
      <div className="ln-reg__inner">
        <div className="ln-reg__head">
          <span className="ln-eyebrow">{t("ln_reg_eyebrow")}</span>
          <h1 className="ln-reg__title">{t("Sign up")}</h1>
          <p className="ln-lead">{t("ln_signup_text")}</p>
        </div>

        <div className="ln-reg__card">
          <ol className="ln-reg__steps">
            {steps.map((label, i) => (
              <li
                key={label}
                className={i < step ? "is-done" : i === step ? "is-current" : ""}
              >
                <span className="ln-reg__step-num">
                  {i < step ? (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
                  ) : (
                    i + 1
                  )}
                </span>
                <span className="ln-reg__step-label">{label}</span>
              </li>
            ))}
          </ol>
          {children}
        </div>

        {step === 0 ? (
          <p className="ln-reg__login">
            {t("ln_have_account")}{" "}
            <Link to="/login">{t("Sign in")}</Link>
          </p>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
export default withTranslation()(RegShell);
